import { List } from "immutable";

import {
  ALREADY_LINKED_TO_PARENT,
  ATTEMPT_TO_CONNECT_TO_OWN_ACCOUNT
} from "services/parentsService/errorTranslator";

import { composeSelector } from "seneca-common/utils/selectors/compose-selectors";

import { StudentParentsMeta } from "../../models/state/meta";
import StudentParentsStateSlice, {
  StudentParentsType
} from "../../models/StudentParentsStateSlice";
import * as metaStateSelectors from "./meta";

const getStudentParentsSlice = (
  state: StudentParentsStateSlice
): StudentParentsType => {
  return state.studentParents;
};

export const getParentIds = (state: StudentParentsStateSlice): List<string> =>
  getStudentParentsSlice(state).keySeq().toList();

export const isParentLinked = (
  state: StudentParentsStateSlice,
  parentId: string
): boolean => {
  const parentIds = getParentIds(state);
  return parentIds.includes(parentId);
};

export const getParentIdByCode = (
  state: StudentParentsStateSlice,
  parentCode: string
): string | null | undefined => {
  const parent = getStudentParentsSlice(state)
    .valueSeq()
    .toList()
    .find(({ code, id }) => code === parentCode);
  return parent && parent.id;
};

const isAlreadyLinkedToParent = (errorMessage: string) =>
  errorMessage === ALREADY_LINKED_TO_PARENT;

export function studentAlreadyLinkedToParent(
  state: StudentParentsStateSlice
): boolean {
  return (
    studentParentUpdateFinished(state) &&
    isAlreadyLinkedToParent(studentParentUpdateErrorMessage(state))
  );
}

export function userAttemptsToConnectToOwnAccount(
  state: StudentParentsStateSlice
): boolean {
  return (
    studentParentUpdateErrored(state) &&
    studentParentUpdateErrorMessage(state) === ATTEMPT_TO_CONNECT_TO_OWN_ACCOUNT
  );
}

//meta
export const getMetaState = (
  state: StudentParentsStateSlice
): StudentParentsMeta => {
  return state.meta as unknown as StudentParentsMeta;
};

// fetch
export const studentParentsAreFetching: (
  arg0: StudentParentsStateSlice
) => boolean = composeSelector(
  getMetaState,
  metaStateSelectors.studentParentsAreFetching
);
export const studentParentsFetchSucceeded: (
  arg0: StudentParentsStateSlice
) => boolean = composeSelector(
  getMetaState,
  metaStateSelectors.studentParentsFetchSucceeded
);
export const studentParentsFetchErrored: (
  arg0: StudentParentsStateSlice
) => boolean = composeSelector(
  getMetaState,
  metaStateSelectors.studentParentsFetchErrored
);
export const studentParentsFetchFinished: (
  arg0: StudentParentsStateSlice
) => boolean = composeSelector(
  getMetaState,
  metaStateSelectors.studentParentsFetchFinished
);
export const studentParentsNeedFetching: (
  arg0: StudentParentsStateSlice
) => boolean = composeSelector(
  getMetaState,
  metaStateSelectors.studentParentsNeedFetching
);

//update
export const studentParentIsUpdating: (
  arg0: StudentParentsStateSlice
) => boolean = composeSelector(
  getMetaState,
  metaStateSelectors.studentParentIsUpdating
);
export const studentParentUpdateSucceeded: (
  arg0: StudentParentsStateSlice
) => boolean = composeSelector(
  getMetaState,
  metaStateSelectors.studentParentUpdateSucceeded
);
export const studentParentUpdateErrored: (
  arg0: StudentParentsStateSlice
) => boolean = composeSelector(
  getMetaState,
  metaStateSelectors.studentParentUpdateErrored
);
export const studentParentUpdateFinished: (
  arg0: StudentParentsStateSlice
) => boolean = composeSelector(
  getMetaState,
  metaStateSelectors.studentParentUpdateFinished
);
export const studentParentUpdateErrorMessage: (
  arg0: StudentParentsStateSlice
) => string = composeSelector(
  getMetaState,
  metaStateSelectors.studentParentUpdateErrorMessage
);
